import styled from 'styled-components';

export const CropTitle = styled.div`
  padding-bottom: 12px;
  ${({ theme }) => theme.textStyles.heading03global03};
`;

export const CropWrap = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${({ theme }) => theme.textStyles.heading01global03};
  padding: 48px;
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/ImageCrop/ImageCrop.styled.js